import Link from "next/link";

const Banner = () => {
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="inner text-center">
              <div className="section-title mb--20">
                <span className="subtitle bg-coral-opacity">About Us</span>
              </div>
              <h1 className="title display-one text-white">
                &quot;Journey of thousand <br />
                miles begins 
                with a single step.&quot;
              </h1>
             
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
